export const INVENTORY_TAGS = {
  MM  : ['<make>','<model>','<detail>','<cta>','<state>'],
  ALL : ['<make>','<model>','<detail>','<cta>','<state>','<year>']
}

export const BRANDING_TAGS = ['<make>','<city>','<name>']
